import axios from 'axios';
import { API_BASE_URL, RAYCHAT_IMAGES_URL } from 'utils/constants';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,

  headers: {
    'Content-Type': 'application/json',
  },
});

export const handleFetchWidgetSettings = async (id) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: `/saveDesign/${id}`,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handlePostWidgetSettings = async (settings) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/saveDesign',
    data: settings,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleUploadWidgetLogo = async (formData, onUploadProgress) => {
  const response = await axios({
    method: 'post',
    baseURL: RAYCHAT_IMAGES_URL,
    url: '/v1/Upload/uploadPhoto',
    data: formData,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
    },
    onUploadProgress,
  });
  return response.data;
};

export const handleGetWidgetAndAutoMessageSettings = async (channelId) => {
  const res = await axiosInstance.get(`saveDesign/${channelId}`);

  return res.data;
};

export const handleAddNewAutoMessage = async (payload) => {
  const res = await axiosInstance.post('trigger/set', payload);

  return res.data;
};

export const handleGetChannelInfo = async (channelId) => {
  const res = await axiosInstance.get(`/channel/setting/${channelId}`);

  return res.data;
};

export const handleUpdateAutoMessage = async (channelId, payload) => {
  const res = await axiosInstance.put(
    `trigger/update/${channelId}`,
    JSON.stringify(payload)
  );

  return res.data;
};

export const handleDeleteAutoMessage = async (channelId, payload) => {
  const res = await axiosInstance.delete(`trigger/delete/${channelId}`, {
    data: payload,
  });

  return res.data;
};

export const handleUpdateOfficeHoursSettings = async (data) => {
  const res = await axiosInstance.post('channels/update', JSON.stringify(data));

  return res.data;
};

export const handleSaveEmailSettings = async (data) => {
  const res = await axiosInstance.post(
    'channels/emailSetting',
    JSON.stringify(data)
  );

  return res.data;
};

export const handleSaveGeneralSettings = async (data) => {
  const res = await axiosInstance.post('setting/channel', JSON.stringify(data));

  return res.data;
};

export const handleUploadSiteLogo = async (formData) => {
  const response = await axios({
    method: 'post',
    baseURL: RAYCHAT_IMAGES_URL,
    url: '/v1/Upload/uploadPhoto',
    data: formData,
    withCredentials: false,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

// RESPONSE DELAY
export const handleGetResponseDelayData = async (channelId) => {
  const response = await axiosInstance.get(`/channel/linger/${channelId}`);

  return response.data;
};

export const handlePutResponseDelayData = async (channelId, data) => {
  const response = await axiosInstance.put(
    `/channel/linger/${channelId}`,
    data
  );

  return response.data;
};

export const handlePostResponseDelayData = async (data) => {
  const response = await axiosInstance.post('/channel/linger', data);

  return response.data;
};

export const handleDeleteResponseDelayData = async (channelId, index) => {
  const response = await axiosInstance.delete(`/channel/linger/${channelId}`, {
    data: {
      index: index,
    },
  });
};

// FORM GENERATOR
export const handlePostFormGeneratorData = async (data) => {
  const response = await axiosInstance.post('form/set', data);

  return response.data;
};

// RESPONSIVE ROBOT
export const handleGetResponsiveRobotData = async (channelId) => {
  const response = await axiosInstance.get(`/channel/bot/${channelId}`);

  return response.data;
};

export const handleDeleteResponsiveRobotData = async (channelId, teamId) => {
  const response = await axiosInstance.delete(`/channel/bot/${channelId}`, {
    data: {
      teamId: teamId,
    },
  });

  return response.data;
};

export const handlePutResponsiveRobotData = async (channelId, data) => {
  const response = await axiosInstance.put(`/channel/bot/${channelId}`, data);

  return response.data;
};

export const handlePostResponsiveRobotData = async (data) => {
  const response = await axiosInstance.post('/channel/bot', data);

  return response.data;
};

export const handleChangeAiBotStatus = async (data) => {
  const response = await axiosInstance.post('/channel/chatbot', data);

  return response.data;
};
